import ko from 'knockout';

function ResponseModel(validationRules) {

  var self = this;

  // Observables
  self.fullName = ko.observable('');
  self.address = ko.observable('');
  self.telephone = ko.observable('');
  self.comments = ko.observable('');
  self.email = ko.observable('');

  self.validationRules = validationRules;
  self.clientErrors = ko.validation.group(self, { deep: true });

  self.setEmail = email => {
    self.email(email);
  };
}

export default ResponseModel;
